import React from 'react';

type TemplateData = {
  [key: string]: string | number | JSX.Element;
};

type StringTemplateProps = {
  str: string;
  template?: TemplateData;
};

const StringTemplate = ({ str, template }: StringTemplateProps) => {
  if (!template) return <>{str}</>;

  const buildTemplate = () => {
    const regex = new RegExp(
      Object.keys(template)
        .map(key => `({${key}})`)
        .join('|'),
      'g',
    );

    return str
      .replace(/\\n/g, '\n')
      .split(regex)
      .reduce<React.ReactNode[]>((arr, element) => {
        if (!element) return arr;
        const match = element.match('^{(\\w+)}$');
        if (match) {
          return arr.concat(template[match[1]]);
        }
        return arr.concat(element);
      }, []);
  };

  return <>{buildTemplate()}</>;
};

export default StringTemplate;
